// client/src/store/slices/TeacherSlice.js
// Manages authenticated teacher/staff state

import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    isAuthenticated: false,
    teacher: null,
};

const teacherSlice = createSlice({
    name: 'teacher',
    initialState,
    reducers: {
        setTeacher(state, action) {
            state.isAuthenticated = true;
            state.teacher = action.payload.teacher;
        },
        clearTeacher(state) {
            state.isAuthenticated = false;
            state.teacher = null;
        },
        updateTeacher(state, action) {
            if (state.teacher) {
                state.teacher = { ...state.teacher, ...action.payload };
            }
        },
    },
});

export const { setTeacher, clearTeacher, updateTeacher } = teacherSlice.actions;
export default teacherSlice.reducer;
